//@flow

// Vendors
import React, { type Node } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Components
import { Loading, SessionManager } from '../../components';

// Actions
import { redirectToSignIn } from '../../reducers/auth/authActions';

type Props = {
  redirectToSignIn: Function,
  isAuthenticated: boolean,
  profile: Object,
  children: Node,
};

const PrivateLayoutBase = ({
  redirectToSignIn,
  isAuthenticated,
  profile,
  children,
}: Props) => {
  if (!isAuthenticated) redirectToSignIn();
  return !profile ? <Loading /> : <SessionManager>{children}</SessionManager>;
};

const mapStateToProps = ({
  auth: { isAuthenticated },
  user: { profile },
}): Object => ({
  isAuthenticated,
  profile,
});

const mapDispatchToProps = (dispatch: Object) =>
  bindActionCreators({ redirectToSignIn }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PrivateLayoutBase);
